import { LoginResponse } from "@syla/shared/types/responses/LoginResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function login(
  email: string,
  password: string,
): Promise<LoginResponse> {
  try {
    const { data } = await axios.post("/users/login", {
      email,
      password,
    });
    return data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
